export enum Lang {
  PT = 'pt',
  EN = 'en',
}

export type LangId = 'pt' | 'en';
